import React from 'react';
import { TextField } from '@mui/material';

const CustomTextField = ({ field, errors, reqs=true, label }) => {
  return (
    <TextField
      required={reqs}
      value={field.value}
      onChange={field.onChange}
      id="filled-required"
      label={label}
      variant="filled"
      fullWidth
      error={errors.model}
      helperText={errors.model ? errors.model.message : ""}
      sx={{
        "& .MuiFilledInput-root": {
          color: "#e8442d",
        },
        "& .MuiFilledInput-input": {
          color: "#e8442d",
        },
        "& .MuiFilledInput-underline:before": {
          borderBottomColor: "#e8442d",
        },
        "& .MuiInputLabel-root": {
          color: "text-#e8442d",
          fontWeight: "900",
        },
        "& .MuiInputLabel-root.Mui-focused": {
          color: "#e8442d",
          fontSize: "1.2rem",
        },

        "& .MuiFormLabel-filled": {
          color: "#e8442d",
        },

        "& .MuiFormLabel-root.Mui-focused": {
          color: "#e8442d",
        },

        "& .MuiFilledInput-underline.MuiFilledInput-underline:hover:before": {
          borderBottomColor: "#e8442d",
        },
        "& .MuiFilledInput-underline:after": {
          borderBottomColor: "#e8442d",
        },
      }}
    />
  );
};

export default CustomTextField;
